import React from "react";
import { Link } from "gatsby";
import fjj from "../assets/images/3unitFJJ.jpg";
import tqj from "../assets/images/TQJ.jpg";
import byj from "../assets/images/BYJ.jpg";
import sg_byj from "../assets/images/3g_byj.png";
import zx_fjj from "../assets/images/zx_fjj.png";
import rmhj from "../assets/images/rmhj.png";
import yd_byj from "../assets/images/yd_byj.png";
import zzs_fjj from "../assets/images/zzs_fjj.png"
const Machine = () => {
  return (
    <section className="course-one course-page">
      <div className="container">
        <div className="row">

        <div className="col-lg-4">
            <div className="course-one__single">
              <div className="course-one__image" >
                <img src={zzs_fjj} alt="" />
                <i className="far fa-heart"></i>
              </div>
              <div className="course-one__content">
                <a href="/zzs_fjj-details" className="course-one__category">
                 智能分拣设备
                </a>
                <h2 className="course-one__title">
                  <Link to="/zzs_fjj-details">智能分拣设备(Vortex系列)</Link>
                </h2>
                <div className="course-one__stars">
                  <span className="course-one__stars-wrap">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </span>
                  <span className="course-one__count">4.8</span>
                  <span className="course-one__stars-count">250</span>
                </div>
                <a href="/zzs_fjj-details" className="course-one__link">
                  查看详情
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="course-one__single">
              <div className="course-one__image" style={{backgroundColor:"#c0eff7"}}>
                <img src={fjj} alt="" />
                <i className="far fa-heart"></i>
              </div>
              <div className="course-one__content">
                <a href="/fjj-details" className="course-one__category">
                  智能分拣设备
                </a>
                <h2 className="course-one__title">
                  <Link to="/fjj-details">智能分拣设备</Link>
                </h2>
                <div className="course-one__stars">
                  <span className="course-one__stars-wrap">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </span>
                  <span className="course-one__count">4.8</span>
                  <span className="course-one__stars-count">250</span>
                </div>
                <a href="/fjj-details" className="course-one__link">
                  查看详情
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="course-one__single">
              <div className="course-one__image">
                <img src={tqj} alt="" />
                <i className="far fa-heart"></i>
              </div>
              <div className="course-one__content">
                <a href="/tqj-details" className="course-one__category">
                  智能贴签设备
                </a>
               <h2 className="course-one__title">
                  <Link to="/tqj-details">智能贴签设备</Link>
                </h2>
                <div className="course-one__stars">
                  <span className="course-one__stars-wrap">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </span>
                  <span className="course-one__count">4.8</span>
                  <span className="course-one__stars-count">250</span>
                </div>
               <a href="/tqj-details" className="course-one__link">
                  查看详情
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="course-one__single">
              <div className="course-one__image">
                <img src={byj} alt="" />
                <i className="far fa-heart"></i>
              </div>
              <div className="course-one__content">
                <a href="/byj-details" className="course-one__category">
                  智能摆药设备
                </a>
               <h2 className="course-one__title">
                  <Link to="/byj-details">智能摆药设备</Link>
                </h2>
                <div className="course-one__stars">
                  <span className="course-one__stars-wrap">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </span>
                  <span className="course-one__count">4.8</span>
                  <span className="course-one__stars-count">250</span>
                </div>
              <a href="/byj-details" className="course-one__link">
                   查看详情
                </a>
              </div>
            </div>
          </div>
        
          <div className="col-lg-4">
            <div className="course-one__single">
              <div className="course-one__image" >
                <img src={zx_fjj} alt="" />
                <i className="far fa-heart"></i>
              </div>
              <div className="course-one__content">
                <a href="/zx_fjj-details" className="course-one__category">
                 智能分拣设备
                </a>
                <h2 className="course-one__title">
                  <Link to="/zx_fjj-details">智能直线分拣机</Link>
                </h2>
                <div className="course-one__stars">
                  <span className="course-one__stars-wrap">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </span>
                  <span className="course-one__count">4.8</span>
                  <span className="course-one__stars-count">250</span>
                </div>
                <a href="/zx_fjj-details" className="course-one__link">
                  查看详情
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="course-one__single">
              <div className="course-one__image" style={{height:250}}>
                <img src={sg_byj} alt="" />
                <i className="far fa-heart"></i>
              </div>
              <div className="course-one__content">
                <a href="/sg_byj-details" className="course-one__category">
                  智能摆药设备
                </a>
               <h2 className="course-one__title">
                  <Link to="/sg_byj-details">智能三柜摆药机</Link>
                </h2>
                <div className="course-one__stars">
                  <span className="course-one__stars-wrap">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </span>
                  <span className="course-one__count">4.8</span>
                  <span className="course-one__stars-count">250</span>
                </div>
               <a href="/sg_byj-details" className="course-one__link">
                  查看详情
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="course-one__single">
              <div className="course-one__image">
                <img src={rmhj} alt="" />
                <i className="far fa-heart"></i>
              </div>
              <div className="course-one__content">
                <a href="/rmhj-details" className="course-one__category">
                  智能摆药设备
                </a>
               <h2 className="course-one__title">
                  <Link to="/rmhj-details">智能溶媒货架</Link>
                </h2>
                <div className="course-one__stars">
                  <span className="course-one__stars-wrap">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </span>
                  <span className="course-one__count">4.8</span>
                  <span className="course-one__stars-count">250</span>
                </div>
              <a href="/rmhj-details" className="course-one__link">
                   查看详情
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="course-one__single">
              <div className="course-one__image">
                <img src={yd_byj} alt="" />
                <i className="far fa-heart"></i>
              </div>
              <div className="course-one__content">
                <a href="/yd_byj-details" className="course-one__category">
                  智能摆药设备
                </a>
               <h2 className="course-one__title">
                  <Link to="/yd_byj-details">智能移动摆药机</Link>
                </h2>
                <div className="course-one__stars">
                  <span className="course-one__stars-wrap">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </span>
                  <span className="course-one__count">4.8</span>
                  <span className="course-one__stars-count">250</span>
                </div>
              <a href="/yd_byj-details" className="course-one__link">
                   查看详情
                </a>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-4">
            <div className="course-one__single">
              <div className="course-one__image">
                <img src={course4} alt="" />
                <i className="far fa-heart"></i>
              </div>
              <div className="course-one__content">
                <a href="#none" className="course-one__category">
                  Photography
                </a>
                <div className="course-one__admin">
                  <img src={team4} alt="" />
                  by <Link to="/teacher-details">Ernest Rodriquez</Link>
                </div>
                <h2 className="course-one__title">
                  <Link to="/course-details">Basics of photogra</Link>
                </h2>
                <div className="course-one__stars">
                  <span className="course-one__stars-wrap">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </span>
                  <span className="course-one__count">4.8</span>
                  <span className="course-one__stars-count">250</span>
                </div>
                <div className="course-one__meta">
                  <a href="/course-details">
                    <i className="far fa-clock"></i> 10 Hours
                  </a>
                  <a href="/course-details">
                    <i className="far fa-folder-open"></i> 6 Lectures
                  </a>
                  <a href="/course-details">$18</a>
                </div>
                <a href="#none" className="course-one__link">
                  See Preview
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="course-one__single">
              <div className="course-one__image">
                <img src={course5} alt="" />
                <i className="far fa-heart"></i>
              </div>
              <div className="course-one__content">
                <a href="#none" className="course-one__category">
                  marketing
                </a>
                <div className="course-one__admin">
                  <img src={team5} alt="" />
                  by <Link to="/teacher-details">Isabella Stanley</Link>
                </div>
                <h2 className="course-one__title">
                  <Link to="/course-details">Affiliate bootcamp</Link>
                </h2>
                <div className="course-one__stars">
                  <span className="course-one__stars-wrap">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </span>
                  <span className="course-one__count">4.8</span>
                  <span className="course-one__stars-count">250</span>
                </div>
                <div className="course-one__meta">
                  <a href="/course-details">
                    <i className="far fa-clock"></i> 10 Hours
                  </a>
                  <a href="/course-details">
                    <i className="far fa-folder-open"></i> 6 Lectures
                  </a>
                  <a href="/course-details">$18</a>
                </div>
                <a href="#none" className="course-one__link">
                  See Preview
                </a>
              </div>
            </div>
          </div> */}
          {/* <div className="col-lg-4">
            <div className="course-one__single">
              <div className="course-one__image">
                <img src={course6} alt="" />
                <i className="far fa-heart"></i>
              </div>
              <div className="course-one__content">
                <a href="#none" className="course-one__category">
                  Health &amp; Fitness
                </a>
                <div className="course-one__admin">
                  <img src={team6} alt="" />
                  by <Link to="/teacher-details">Katherine Collins</Link>
                </div>
                <h2 className="course-one__title">
                  <Link to="/course-details">Healthy workout ti</Link>
                </h2>
                <div className="course-one__stars">
                  <span className="course-one__stars-wrap">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </span>
                  <span className="course-one__count">4.8</span>
                  <span className="course-one__stars-count">250</span>
                </div>
                <div className="course-one__meta">
                  <a href="/course-details">
                    <i className="far fa-clock"></i> 10 Hours
                  </a>
                  <a href="/course-details">
                    <i className="far fa-folder-open"></i> 6 Lectures
                  </a>
                  <a href="/course-details">$18</a>
                </div>
                <a href="#none" className="course-one__link">
                  See Preview
                </a>
              </div>
            </div>
          </div> */}
        </div>
        <div className="post-pagination">
          <a href="#none">
            <i className="fa fa-angle-double-left"></i>
          </a>
          <a className="active" href="#none">
            1
          </a>
          {/* <a href="#none">2</a>
          <a href="#none">3</a>
          <a href="#none">4</a> */}
          <a href="#none">
            <i className="fa fa-angle-double-right"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Machine;
